import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"Apostille ปริญญา — รับรองใบปริญญาและทรานสคริปต์ไทยเพื่อใช้ต่างประเทศ","metaTitle":"Apostille ปริญญา ทรานสคริปต์ ไทย ใช้ต่างประเทศ 130 ประเทศ | NYC","metaDesc":"รับรอง Apostille ใบปริญญา ทรานสคริปต์ ประกาศนียบัตร จากมหาวิทยาลัยไทย เพื่อสมัครงาน/เรียนต่อ/ขอ Work Permit ใน 126 — ปรึกษาฟรีก่อนยื่นจริง ลดโอกาสเอกสารตีกลับ"},"en":{"h1":"Apostille Thai Degree — Certified Diploma & Transcript for Global Use","metaTitle":"Apostille Thai Degree & Transcript | Employment, Study, License | NYC","metaDesc":"Apostille Thai university degrees and transcripts for overseas jobs, further study, work permits and — Get your timeline and checklist in minutes — chat now."}} as const;

export const Route = createFileRoute("/apostille/degree")({
  head: () => {
    const url = `${SEO_SITE}/apostille/degree`;
    const c = meta.th;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/apostille/degree", "th")},
        { name: "description", content: ctaDesc(c.metaDesc, "/apostille/degree", "th")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/apostille/degree", "th")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/apostille/degree", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/apostille/degree", "/en/apostille/degree")],
    };
  },
  component: () => <SubServicePage slug="apostille/degree" locale="th" />,
});
